var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-nav-bar',{staticClass:"backBox",attrs:{"title":"","right-text":"","left-arrow":""},on:{"click-left":_vm.onClickLeft}}),_c('BarScan',{ref:"qrcode",on:{"ok":_vm.getResult,"err":_vm.geterror}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }